import React from 'react';

const LeadEditForm = ({
  formData,
  errors,
  handleChange,
  boats
}) => {
  return (
    <div className="form">

<div className="form-group-row">
        <div className="form-group">
          <select
            name="boat_id"
            value={formData.boat?.id || ''}
            onChange={handleChange}
            className={errors.boat ? 'error' : ''}
          >
            <option value="">Select Boat (optional)</option>
            {boats.map((boat) => (
              <option key={boat.id} value={boat.id}>
                {boat.name}
              </option>
            ))}
          </select>
          <div className="error-message-container">
            <p className="error-message">{errors.boat_id}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="Full Name*"
            className={errors.fullName ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.fullName}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email*"
            className={errors.email ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.email}</p>
          </div>
        </div>

        <div className="form-group">
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone*"
            className={errors.phone ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.phone}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <input
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            placeholder="Date (optional)"
            className={errors.date ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.date}</p>
          </div>
        </div>
      </div>

      <div className="form-group-row">
        <div className="form-group">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message (optional)"
            className={errors.message ? 'error' : ''}
          />
          <div className="error-message-container">
            <p className="error-message">{errors.message}</p>
          </div>
        </div>
      </div>


    </div>
  );
};

export default LeadEditForm;